import React from 'react';
import Svg, { Path, Text as SvgText } from 'react-native-svg';

import {
  getAQIColor,
  getContrastTextColor,
  getStationAQI,
} from '../../utils/aqi';
import type { Station } from '../../types/station';

type CloudStationIconProps = {
  station: Station;
  borderColor?: string;
  borderWidth?: number;
};

const CLOUD_PATH =
  'M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z';

const getFontSize = (value: number | null): number => {
  if (value === null || value < 100) {
    return 8;
  }
  if (value < 1000) {
    return 7;
  }
  return 6;
};

const CloudStationIcon = ({
  station,
  borderColor = '#ffffff',
  borderWidth = 1,
}: CloudStationIconProps) => {
  const aqi = getStationAQI(station);
  const color = getAQIColor(aqi);
  const textColor = getContrastTextColor(color);

  return (
    <Svg width={44} height={44} viewBox="0 0 24 24">
      <Path
        d={CLOUD_PATH}
        fill={color}
        stroke={borderColor}
        strokeWidth={borderWidth}
      />
      <SvgText
        x={12}
        y={16}
        fill={textColor}
        fontSize={getFontSize(aqi)}
        fontWeight="700"
        textAnchor="middle"
      >
        {aqi ?? '—'}
      </SvgText>
    </Svg>
  );
};

export default CloudStationIcon;
